module.exports = __webpack_public_path__ + "img/st.e72da304.png";